import Client from '@/app/repository/axios-client';

const resource = '/account/employees';

export default {
  create(payload) {
    return Client.post(`${resource}`, payload);
  },
  update(accountId, payload) {
    return Client.put(`${resource}/${accountId}`, payload);
  },
  changeRole(accountId, payload) {
    return Client.patch(`${resource}/${accountId}/role`, payload);
  },
  getMe() {
    return Client.get(`${resource}/me`);
  },
  getAccount(accountId) {
    return Client.get(`${resource}/${accountId}`);
  },
  activate(accountId, payload) {
    return Client.patch(`${resource}/${accountId}/activate`, payload);
  },
  deactivate(accountId, payload) {
    return Client.patch(`${resource}/${accountId}/deactivate`, payload);
  },
  getAccountForGrid(parameters) {
    return Client.get(`${resource}` + parameters);
  },
};
